
module.exports = (val, caret) => {
    if (['.', ',', '-.', '-,'].indexOf(val) >= 0) {
        return {value: "", caret: 0}
    }
    let originalCaret = caret;
    let ret = [];
    let wasComa = false;
    for (let i = 0; i < val.length; i++) {
        const char = val.charAt(i);
        if(i === 0 && ["+", "-"].indexOf(char) >=0) {
            if(val.length === 1) {
                ret.push('-');
                continue;
            }
            ret.push(char);
            continue;
        }
        if(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].indexOf(char) >=0) {
            ret.push(char);
            continue;
        }
        if(!wasComa && [".", ","].indexOf(char) >=0) {
            wasComa = true;
            ret.push('.');
            continue;
        }
        if(i <= originalCaret) {
            caret--;
        }
    }
    if(ret.length === 0) {
        return {value: "", caret: 0}
    }
    if (ret.length === 1 && ret[0] === '-') {
        return {value: "-", caret: originalCaret === 0 ? 0: 1}
    }
    originalCaret = caret;
    const num = Number.parseFloat(ret.join(""));
    const number = num.toString().replace('.', ',');
    let dotIndex = number.indexOf(',');
    if(dotIndex < 0) {
        dotIndex = number.length;
    }
    const appendix = number.substring(dotIndex);

    let decimalCounter = 0;
    ret = appendix;
    for (let i = dotIndex - 1; i >= 0; i--) {
        ret = number.charAt(i) + ret;
        if(decimalCounter++ % 3 === 2) {
            if(i !== 0 && !(i === 1 && number[0] === '-')) {
                if (i <= originalCaret) {
                    caret++;
                }
                ret = " " + ret;
            }
        }
    }

    const endsWithComa = val.endsWith(".") || val.endsWith(",");
    return {value: ret + ((ret.indexOf(',') < 0 && endsWithComa) ? ",": ""), caret, num};
};